import React from 'react';
import {Portal} from 'components';
import css from './page-lock.module.scss';

export function PageLock() {
  return (
    <Portal>
      <div className={css.pageLock} />
    </Portal>
  );
}
